export class PrismObject {
  x: number;  // LEFT
  y: number;  // TOP


  constructor(xOrigin: number, yOrigin: number) {
    this.x = xOrigin;
    this.y = yOrigin;
  }
}

export class PRISMResult {
  doctorID: string;
  patientSSN: string;
  self: PrismObject;
  disease: PrismObject;
  distance: string;


  constructor(doctorID: string, patientSSN: string, self: PrismObject, disease: PrismObject, distance: string) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.self = self;
    this.disease = disease;
    this.distance = distance;
  }
}
